interface VisitedAirport {
  id: string;
  airport_code: string; // Now we store airport_code (e.g. LAX, JFK) instead of all the details
  visited_at: string;
  aircraft?: string;
  airline?: string;
}

export const visitedAirportsDemo: VisitedAirport[] = [
  {
    id: "demo-1",
    airport_code: "LAX",
    visited_at: "2024-01-15T10:30:00Z",
    aircraft: "Boeing 737-800",
    airline: "American Airlines",
  },
  {
    id: "demo-2",
    airport_code: "JFK",
    visited_at: "2024-02-20T14:15:00Z",
    aircraft: "Airbus A320",
    airline: "Delta Air Lines",
  },
  {
    id: "demo-3",
    airport_code: "LHR",
    visited_at: "2024-03-05T08:45:00Z",
    aircraft: "Boeing 777-200",
    airline: "British Airways",
  },
  {
    id: "demo-4",
    airport_code: "CDG",
    visited_at: "2024-03-12T16:20:00Z",
    aircraft: "Airbus A350",
    airline: "Air France",
  },
  {
    id: "demo-5",
    airport_code: "NRT",
    visited_at: "2024-04-08T12:10:00Z",
    aircraft: "Boeing 787-9",
    airline: "ANA",
  },
  {
    id: "demo-6",
    airport_code: "SYD",
    visited_at: "2024-05-18T22:30:00Z",
    aircraft: "Airbus A380",
    airline: "Qantas",
  },
  {
    id: "demo-7",
    airport_code: "DXB",
    visited_at: "2024-06-02T06:15:00Z",
    aircraft: "Boeing 777-300ER",
    airline: "Emirates",
  },
  {
    id: "demo-8",
    airport_code: "SIN",
    visited_at: "2024-07-14T18:45:00Z",
    aircraft: "Airbus A350-900",
    airline: "Singapore Airlines",
  },
  {
    id: "demo-9",
    airport_code: "ICN",
    visited_at: "2024-08-25T11:25:00Z",
    aircraft: "Boeing 787-10",
    airline: "Korean Air",
  },
  {
    id: "demo-10",
    airport_code: "FRA",
    visited_at: "2024-09-10T13:50:00Z",
    aircraft: "Airbus A330",
    airline: "Lufthansa",
  },
];
